import React from "react"
import Link from "gatsby-link"
import {Auth} from "aws-amplify";
import '../../styles.scss';

async function signOut(e: Event) {
  try {
    e.preventDefault()
    Auth.signOut().then(() => window.location.reload())
  } catch (error) {
    console.log('error signing out: ', error);
  }
}

const TopNav = () =>
  <div>
    <Link className="pa3" to="/app/c/2023/c2023/category">Ladda upp bidrag</Link>
    <Link className="pa3" to="/app/c/submissions">Uppladdade bidrag</Link>
    <a className="pa3" href="#" onClick={signOut}>Logga ut</a>
  </div>

export default TopNav
